var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.346,
    height: 12.008,
    viewBox: "0 0 73.346 12.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1762",
    "data-name": "Group 1762",
    transform: "translate(-125.82 -145.991)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(123.57 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-2",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(138.769 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-3",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(153.969 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-4",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(169.168 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star-5",
    "data-name": "Icon feather-star",
    d: "M8.524,3l1.707,3.458,3.817.558-2.762,2.69.652,3.8-3.414-1.8-3.414,1.8.652-3.8L3,7.016l3.817-.558Z",
    transform: "translate(184.367 143.741)",
    fill: "#ffc400",
    stroke: "#ffc400",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.1060168345fb5b6170e4734375dc0adc.svg";
export { ForwardRef as ReactComponent };